<app-dialog>
  <div mat-dialog-title>
    <div class="title-container">
      <app-text [tag]="'h2'">
        {{ announcement?.title }}
      </app-text>
    </div>

    <app-button
      [size]="'small'"
      [isIcon]="true"
      [color]="'transparent'"
      mat-dialog-close
    >
      <app-icon [iconName]="'close-icon'"></app-icon>
    </app-button>
  </div>

  @if (announcement?.description) {
    <mat-dialog-content>
      <div
        class="dialog-custom-html-content"
        [innerHTML]="announcement?.description"
      ></div>

      <mat-checkbox [(ngModel)]="dontShowAgain">
        Don't show this again
      </mat-checkbox>
    </mat-dialog-content>
  }

  <div>
    <mat-dialog-actions
      *ngIf="announcement?.cta_url && announcement?.cta_button"
    >
      <app-button
        [size]="'large'"
        [color]="'secondary-outlined'"
        [width]="'143px'"
        (clicked)="closeDialogHandler()"
      >
        Cancel
      </app-button>

      <app-button
        [size]="'large'"
        [color]="'primary'"
        (clicked)="submitButtonAction()"
        [minWidth]="'143px'"
      >
        {{ announcement?.cta_button }}
      </app-button>
    </mat-dialog-actions>
  </div>
</app-dialog>
